export const API_URL:string = "https://api.cushwake.com.au"
export const APP_URL:string = "https://app.cushwake.com.au"
export const API_KEY:string = "ck_dda76a2efeb436e623013fbc1e9c8a52c5b9a155"
export const API_SECRET:string = "cs_434802e0540e8fbb52f6f5c6da9e7a898344e1d5"
export const API_USERNAME:string = "apiuser"
export const API_PASSWORD:string = "5DMskH#%@sqKQ(qv8kE&LIEJ"


// WEBPACK FOOTER //
// ./src/core/constants.ts